import { whenDocumentReady } from '../../../../assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let previews = document.querySelectorAll('[paws-component="noss-video"][paws-template="default"] .preview');
    if (previews !== null) {
        for( let x = 0; x <  previews.length; x++ ) {
            previews[x].addEventListener('click', function (event) {
                let video = event.target.closest('[paws-component="noss-video"][paws-template="default"]').querySelector('video');
                video.classList.remove('inactive');
                video.play();
                event.target.closest('[paws-component="noss-video"][paws-template="default"]').querySelector('.preview').parentNode.removeChild(event.target.closest('[paws-component="noss-video"][paws-template="default"]').querySelector('.preview'));
            });
        }
    }
}